import api from './api';

// Contrato único do recurso /crm-automation (CRUD + reorder + toggle).
// Forma de uma automação:
// { id, trigger, action, is_active, priority, pipeline_id, pipeline_stage_id,
//   conditions: [{type:'origin',value:'site'} | {type:'amount',operator:'gte'|'lt',value:<cents>}],
//   action_config: { card_creation_mode, card_responsible_mode, card_responsible_admin_id }
//                | { task_type, task_title, task_due_offset_days },
//   pipeline: {id,name}, stage: {id,name} }
//
// Observação: valores monetários trafegam em centavos (inteiro), como no resto do CRM.

export const listAutomations = (params = {}) => api.get('/crm-automation', { params });

export const createAutomation = (body) => api.post('/crm-automation', body);

export const updateAutomation = (id, body) => api.put(`/crm-automation/${id}`, body);

export const toggleAutomation = (id) => api.patch(`/crm-automation/${id}/toggle`);

export const reorderAutomations = (trigger, orderedIds) =>
    api.put('/crm-automation/reorder', { trigger, ordered_ids: orderedIds });

export const deleteAutomation = (id) => api.delete(`/crm-automation/${id}`);
